<template>
  <div>
    <div class="common">
      <!-- 搜索 -->
      <div class="top clearfix">
        <div class="fl">
          搜索：<el-input
            type="text"
            class="score-input"
            v-model="keyword"
            @change="selectLsit1(1)"
            size="small"
            style="width: 150px"
            placeholder="请输入关键字"
            clearable
          ></el-input>
          学年：
          <el-date-picker
            :clearable="false"
            class="search-year"
            style="width: 100px"
            v-model="searchYear"
            value-format="yyyy"
            size="small"
            type="year"
            @change="selectLsit1(1)"
          >
          </el-date-picker>
          学期：
          <el-select v-model="searchTerm" size="small" @change="selectLsit1(1)">
            <template v-for="i of dic.schoolTerm">
              <el-option
                :key="i.id"
                :label="i.dicName"
                :value="i.dicCode"
              ></el-option>
            </template>
          </el-select>
          学科：
          <el-select
            v-model="disciplineCode"
            placeholder="全部学科"
            @change="selectLsit1(1)"
            clearable
          >
            <el-option
              v-for="i in subjectOptions"
              :key="i.id"
              :label="i.disciplineName"
              :value="i.disciplineCode"
            ></el-option>
          </el-select>
        </div>
        <!-- <div class="fr">
          <el-button
            size="small"
            icon="iconfont icon-daochu"
            @click="importTeacher"
            v-if="isAdmin"
            >导出</el-button
          >
        </div> -->
      </div>
      <!-- 表格 -->
      <el-table
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 0.9)"
        v-loading="isTableLoading"
        row-key="id"
        :data="tableData"
        stripe
        style="width: 100%"
        :header-cell-style="{ background: '#EFEFEF' }"
        @sort-change="sortChange"
      >
        <el-table-column
          prop="teacherName"
          label="姓名"
          width="100"
          fixed="left"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="disciplineName" label="学科"> </el-table-column>
        <el-table-column
          prop="mannerScore"
          label="师德师风"
          sortable="custom"
          align="center"
        />
        <el-table-column
          prop="mentorScore"
          label="班主任、全员导师工作"
          sortable="custom"
          align="center"
        />
        <el-table-column
          prop="routineScore"
          label="常规工作（巡检）"
          sortable="custom"
          align="center"
        />
        <el-table-column
          prop="attendanceScore"
          label="教师考勤"
          sortable="custom"
          align="center"
        />
        <el-table-column
          prop="otherScore"
          label="其他工作参与"
          sortable="custom"
        />
        <el-table-column label="操作" width="250" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              class="text-edit"
              @click="showManage(scope.$index, scope.row)"
              >积分管理
            </el-button>
            <el-button
              type="text"
              class="text-edit"
              @click="showRocord(scope.$index, scope.row)"
              >积分记录</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination
        :pageObj="pageObj"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></pagination>
      <!-- 积分管理的对话框 -->
      <el-dialog
        class="add-pop"
        :visible.sync="manageVisible"
        :close-on-click-modal="false"
        width="40%"
      >
        <template v-slot:title>
          <div class="add-title">积分管理</div>
        </template>
        <!-- 对话框内容部分 => 匿名插槽 -->
        <el-form ref="form" :rules="rules" :model="form" label-width="140px">
          <el-form-item label="教师姓名" prop="teacherName">
            <el-input readonly v-model="form.teacherName"></el-input>
          </el-form-item>
          <el-form-item label="积分类型" prop="classify">
            <el-select v-model="form.classify" placeholder="请选择">
              <template v-for="i of classifyListOpions">
                <el-option
                  :key="i.code"
                  :label="i.name"
                  :value="i.code"
                ></el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="积分变更" prop="type">
            <el-radio v-model="form.type" :label="1">加分</el-radio>
            <el-radio v-model="form.type" :label="0">减分</el-radio>
          </el-form-item>
          <el-form-item label="变更数值" prop="score">
            <el-input :min="0" type="number" v-model="form.score"></el-input>
          </el-form-item>
          <el-form-item label="变更原因" prop="remark">
            <el-input
              v-model="form.remark"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }"
            ></el-input> </el-form-item
        ></el-form>
        <template v-slot:footer>
          <span class="dialog-footer">
            <el-button @click="submit" type="primary">提 交</el-button>
          </span>
        </template>
      </el-dialog>
      <!-- 积分记录的对话框 -->
      <el-dialog
        class="add-pop"
        :visible.sync="rocordVisible"
        :close-on-click-modal="false"
        width="60%"
      >
        <template v-slot:title>
          <div class="add-title">积分记录</div>
        </template>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane
            v-for="item in classifyListOpions"
            :key="item.code"
            :label="item.name"
            :name="item.code"
          >
            <el-table
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(255, 255, 255, 0.9)"
              v-loading="isModalTableLoading"
              row-key="id"
              :data="modalTableData"
              style="width: 100%"
              :header-cell-style="{ background: '#EFEFEF' }"
            >
              <el-table-column
                prop="teacherName"
                label="积分变更"
                align="center"
              >
                <template slot-scope="scope">
                  <span
                    >{{ scope.row.type == 1 ? "+" : "-"
                    }}{{ scope.row.score }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column prop="remark" label="变更原因" align="center">
              </el-table-column>
              <el-table-column
                prop="createTime"
                label="变更时间"
                align="center"
              >
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
        <!-- 分页 -->
        <pagination
          :pageObj="modalPageObj"
          @handleSizeChange="modalHandleSizeChange"
          @handleCurrentChange="modalHandleCurrentChange"
        ></pagination>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination.vue";
import { exportExecl } from "@/utils/index";
import { mapState } from "vuex";
export default {
  components: {
    Pagination,
  },
  computed: {
    ...mapState([
      "scoreMenuList",
      "isAdmin",
      "userInfo",
      "dic",
      "teacherLoading",
    ]),
    scoreMenuCodeList() {
      return this.scoreMenuList.map((item) => item.menuCode);
    },
  },
  data() {
    return {
      selectRow: null,
      isTableLoading: false,
      isModalTableLoading: false,
      manageVisible: false,
      rocordVisible: false,
      searchYear: "",
      searchTerm: "",
      keyword: "",
      activeName: "",
      disciplineCode: "",
      tableData: [],
      modalTableData: [],
      subjectOptions: [],
      classifyListOpions: [],
      pageObj: {
        current: 1,
        total: 0,
        size: 10,
        sizeList: [10, 15, 20, 25, 30],
      },
      modalPageObj: {
        current: 1,
        total: 0,
        size: 10,
        sizeList: [10, 15, 20, 25, 30],
      },
      form: {
        teacherName: "",
        classify: "",
        type: "",
        score: "",
        remark: "",
      },
      rules: {
        classify: [
          {
            required: true,
            message: "请选择积分类型",
            trigger: "change",
          },
        ],
        type: [
          {
            required: true,
            message: "请选择积分变更类型",
            trigger: "change",
          },
        ],
        score: [
          {
            required: true,
            message: "请输入积分变更数值",
            trigger: "change",
          },
        ],
        remark: [
          {
            required: true,
            message: "请输入变更原因",
            trigger: "change",
          },
        ],
      },
    };
  },
  created() {
    this.searchYear = this.curYearPro;
    this.searchTerm = this.curTermPro;
    this.getTeacherPerformanceClassifyList();
    this.getDicSubject();
    this.selectLsit1(1); //首页list
  },
  methods: {
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          console.log(this.form);
          this.$axios
            .post("/performance/updateTeacherPerformanceScore", {
              ...this.form,
              operatorId: this.userInfo.userId,
              schoolCode: this.userInfo.schoolCode,
              teacherId: this.selectRow.teacherId,
              schoolTerm: this.searchTerm,
              schoolYear: this.searchYear,
            })
            .then((res) => {
              if (res.resultCode === 200) {
                this.$message({
                  type: "success",
                  message: "操作成功",
                });
                this.selectLsit1(1);
                this.manageVisible = false;
              } else {
                this.$message({
                  type: "error",
                });
              }
            });
        }
      });
    },
    handleClick(tab) {
      this.activeName = tab.name;
      this.ModalselectLsit1(1, 10);
    },
    showRocord(index, row) {
      this.selectRow = row;
      this.ModalselectLsit1(1);
      this.rocordVisible = true;
    },
    showManage(index, row) {
      this.selectRow = row;
      this.$refs.form && this.$refs.form.resetFields();
      //查询教师的选择
      this.form = {
        id: row.id,
        teacherName: row.teacherName,
      };
      this.manageVisible = true;
    },
    ModalselectLsit1(curPage, pageSize) {
      let homeForm = {
        schoolCode: this.userInfo.schoolCode,
        pageNum: curPage || this.modalPageObj.current,
        pageSize: pageSize || this.modalPageObj.size,
        schoolTerm: this.searchTerm,
        schoolYear: this.searchYear,
        classify: this.activeName,
        teacherId: this.selectRow.teacherId,
      };
      this.isModalTableLoading = true;
      this.$axios
        .post("/performance/getTeacherPerformanceScoreRecordList", homeForm)
        .then((res) => {
          if (res.resultCode === 200) {
            this.modalPageObj.size = res.data.size;
            this.modalPageObj.current = res.data.current;
            this.modalPageObj.total = res.data.total;
            this.modalTableData = res.data.records;
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
          this.isModalTableLoading = false;
        })
        .catch((err) => {
          this.isModalTableLoading = false;
        });
    },
    //首页 查询首页list
    selectLsit1(curPage, pageSize, orderBy, orderType) {
      let homeForm = {
        schoolCode: this.userInfo.schoolCode,
        pageNum: curPage || this.pageObj.current,
        pageSize: pageSize || this.pageObj.size,
        schoolTerm: this.searchTerm || "",
        schoolYear: this.searchYear || "",
        orderBy: orderBy,
        orderType: orderType,
        keyword: this.keyword || "",
        disciplineCode: this.disciplineCode || "",
      };
      this.isTableLoading = true;
      this.$axios
        .post("/performance/getTeacherPerformanceScoreList", homeForm)
        .then((res) => {
          if (res.resultCode === 200) {
            this.pageObj.size = res.data.size;
            this.pageObj.current = res.data.current;
            this.pageObj.total = res.data.total;
            this.tableData = res.data.records;
            console.log(res.data.records);
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
          this.isTableLoading = false;
        })
        .catch((err) => {
          this.isTableLoading = false;
          console.log("教师error", err);
        });
    },
    //获取教师表现类型
    getTeacherPerformanceClassifyList() {
      this.$axios
        .post("/performance/getTeacherPerformanceClassifyList")
        .then((res) => {
          if (res.data && res.data.length > 0) {
            this.classifyListOpions = res.data;
            this.activeName = this.classifyListOpions[0].code;
          }
        });
    },
    //学科
    getDicSubject() {
      const paramsDicSubject = {
        clientPackage: "com.xueduoduo.teacher.archives.pc",
        schoolCode: this.userInfo.schoolCode,
      };
      this.$axios.post("/user/listDiscipline", paramsDicSubject).then((res) => {
        if (res.data.records && res.data.records.length > 0) {
          this.subjectOptions = res.data.records;
        }
      });
    },
    //导出
    importTeacher() {
      // exportExecl(
      //   "/exp/expTeacherResourceInfo",
      //   "资源研发-" + this.userInfo.userName,
      //   this.userInfo.schoolCode,
      //   this.pageObj.current,
      //   this.pageObj.size,
      //   this.searchYear,
      //   this.searchTerm
      // );
    },

    //分页
    modalHandleSizeChange(pageSize) {
      this.modalPageObj.size = pageSize;
      this.ModalselectLsit1(1, pageSize);
    },
    modalHandleCurrentChange(curPage) {
      this.ModalselectLsit1(curPage);
    },
    //分页
    handleSizeChange(pageSize) {
      this.pageObj.size = pageSize;
      this.selectLsit1(1, pageSize);
    },
    handleCurrentChange(curPage) {
      this.selectLsit1(curPage);
    },
    sortChange({ column, prop, order }) {
      console.log(column, prop, order);
      let orderType = "";
      switch (order) {
        case "ascending":
          orderType = 1;
          break;
        case "descending":
          orderType = 0;
          break;
        default:
          orderType = null;
          break;
      }

      this.selectLsit1(1, this.pageObj.size, prop, orderType); //首页list
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../styles/common.less";
.top {
  .fl {
    width: calc(100% - 100px) !important;
    max-width: 800px !important;
  }
}
</style>
